<template>
  <div class="company-profile-wrapper">
    <!-- company-profile display -->
    <div
      class="company-profile-container"
      v-if="show_list"
      v-animate-css="'fadeIn'"
    >
      <div class="company-profile-body">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: tab == 'inter' }"
            @click="tab = 'inter'"
          >
            New Assignment
          </div>
          <div
            class="tab"
            :class="{ active: tab == 'assing' }"
            @click="tab = 'assing'"
          >
            Assigned
          </div>
          <div
            class="tab"
            :class="{ active: tab == 'our' }"
            @click="tab = 'our'"
          >
            Our Assingment
          </div>
        </div>

        <div class="assignments-item-header">
          <label>Assignments</label>
          <div class="options">
            <button class="add-btn" @click="showAddUpdateForm()">
              Add Assignment +
            </button>
          </div>
        </div>

        <div class="search-add-btn-widget">
          <div class="search-widget" v-if="tab == 'inter' && leads.length > 0">
            <img src="@/assets/icons/search.svg" alt />
            <input
              type="text"
              v-model="search_assignment"
              placeholder="Type in to Search…"
            />
          </div>
          <div
            class="search-widget"
            v-if="tab == 'assing' && user.assignment_assigned > 0"
          >
            <img src="@/assets/icons/search.svg" alt />
            <input
              type="text"
              v-model="search_assignment"
              placeholder="Type in to Search…"
            />
          </div>
        </div>

        <div class="loader" ref="loader" v-show="showLoading"></div>
        <!-- Interested -->
        <ul class="assignments-items" v-if="tab == 'inter'">
          <li class="assignments-starter"></li>
          <li class="assignments-item" v-for="(lead, i) in leads" :key="i">
            <panel-expand :expand="i === 0">
              <template v-slot:header="{ options }">
                <div class="assignments-item-header">
                  <div class="assignments-item-brand">
                    <img
                      v-if="$hasKey(lead, 'user.customer_profile.logo')"
                      @click.prevent="
                        $router.push({
                          name: 'profile_customer',
                          params: { id: lead.user_id },
                        })
                      "
                      :src="
                        $fullUrl(
                          'images/profiles/' + lead.user.customer_profile.logo
                        )
                      "
                    />
                    <img
                      v-else-if="$hasKey(lead, 'user.company_profile.logo')"
                      @click.prevent="
                        $router.push({
                          name: 'profile_customer',
                          params: { id: lead.user_id },
                        })
                      "
                      :src="
                        $fullUrl(
                          'images/profiles/' + lead.user.company_profile.logo
                        )
                      "
                    />
                    <img
                      v-else
                      @click.prevent="
                        $router.push({
                          name: 'profile_customer',
                          params: { id: lead.user_id },
                        })
                      "
                      src="@/assets/icons/logo_avatar.svg"
                    />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label
                        v-if="$hasKey(lead, 'user.company_profile.name')"
                        >{{ lead.user.company_profile.name | validate }}</label
                      >
                      <label v-else>{{ lead.customer | validate }}</label>
                      <span>{{ lead.address | validate }}</span>
                      <span class="date">{{
                        lead.due_date_from | formatDate | validate
                      }}</span>
                    </div>
                    <div class="options">
                      <dropdown-menu>
                        <ul>
                          <li>
                            <a href @click.prevent="assingConsultant(lead)"
                              >Assign</a
                            >
                          </li>
                        </ul>
                      </dropdown-menu>

                      <button
                        class="toogle-panel-btn"
                        @click="options.expanded = !options.expanded"
                        v-if="!options.expanded"
                      >
                        <span class="fa fa-angle-down"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:main="{ options }">
                <div class="assignments-item-body">
                  <div class="assignments-info">
                    <h5>{{ lead.title | validate }}</h5>
                    <img
                      class="cover-img"
                      :src="$fullUrl('images/profiles/' + lead.cover_photo)"
                      v-if="lead.cover_photo"
                      alt
                    />
                    <p v-readMore:200="lead.description"></p>
                    <h5>Skills</h5>
                    <div class="assign-skills-widget">
                      <div
                        class="item"
                        v-for="(skill, i) in lead.skills"
                        :key="i"
                      >
                        <span class="name">{{ skill | validate }}</span>
                      </div>
                    </div>
                    <div class="other-info">
                      <div class="col">
                        <div class="content" v-if="lead.roles">
                          <h5>Role</h5>
                          <p>{{ lead.roles | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.due_date_from">
                          <h5>Start Date</h5>
                          <p>
                            {{ lead.due_date_from | formatDate | validate }}
                            <template v-if="lead.is_urgent"
                              >/ As soon as possible</template
                            >
                          </p>
                        </div>
                      </div>
                      <div class="col">
                        <div class="content" v-if="lead.duration">
                          <h5>Duration</h5>
                          <p>{{ lead.duration | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.workload">
                          <h5>Work Load</h5>
                          <p>{{ lead.workload | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.rate">
                          <h5>Rate</h5>
                          <p>
                            {{ lead.rate | validate }}
                            <template v-if="lead.is_negotiable"
                              >/ Negotiable</template
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="assignments-item-body-option">
                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                    >
                      <span
                        class="fa fa-angle-up"
                        v-show="options.expanded"
                      ></span>
                    </button>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <!-- Assigned  -->
        <ul class="assignments-items" v-if="tab == 'assing'">
          <li class="assignments-starter"></li>
          <li
            class="assignments-item"
            v-for="(lead, i) in user.assignment_assigned"
            :key="i"
          >
            <panel-expand :expand="i === 0">
              <template v-slot:header="{ options }">
                <div class="assignments-item-header">
                  <div class="assignments-item-brand">
                    <img
                      v-if="$hasKey(lead, 'user.customer_profile.logo')"
                      @click.prevent="
                        $router.push({
                          name: 'profile_customer',
                          params: { id: lead.user_id },
                        })
                      "
                      :src="
                        $fullUrl(
                          'images/profiles/' + lead.user.customer_profile.logo
                        )
                      "
                    />
                    <img
                      v-else-if="$hasKey(lead, 'user.company_profile.logo')"
                      @click.prevent="
                        $router.push({
                          name: 'profile_customer',
                          params: { id: lead.user_id },
                        })
                      "
                      :src="
                        $fullUrl(
                          'images/profiles/' + lead.user.company_profile.logo
                        )
                      "
                    />
                    <img
                      v-else
                      @click.prevent="
                        $router.push({
                          name: 'profile_customer',
                          params: { id: lead.user_id },
                        })
                      "
                      src="@/assets/icons/logo_avatar.svg"
                    />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ lead.customer | validate }}</label>
                      <span>{{ lead.address | validate }}</span>
                      <span class="date">{{
                        lead.due_date_from | formatDate | validate
                      }}</span>
                    </div>
                    <div class="options">
                      <button
                        class="toogle-panel-btn"
                        @click="options.expanded = !options.expanded"
                        v-if="!options.expanded"
                      >
                        <span class="fa fa-angle-down"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:main="{ options }">
                <div class="assignments-item-body">
                  <div class="assignments-info">
                    <h5>{{ lead.title | validate }}</h5>
                    <img
                      class="cover-img"
                      :src="$fullUrl('images/profiles/' + lead.cover_photo)"
                      v-if="lead.cover_photo"
                      alt
                    />
                    <p v-readMore:200="lead.description"></p>
                    <h5>Skills</h5>
                    <div class="assign-skills-widget">
                      <div
                        class="item"
                        v-for="(skill, i) in lead.all_skills"
                        :key="i"
                      >
                        <span class="name">{{ skill | validate }}</span>
                      </div>
                    </div>
                    <h5>Assinged Members</h5>
                    <div class="collaboraters-widget">
                      <div
                        class="item"
                        v-for="(item, i) in lead.members"
                        :key="i"
                      >
                        <img
                          v-if="item.profile_picture"
                          class="profile-img"
                          :src="
                            $fullUrl('images/profiles/' + item.profile_picture)
                          "
                          alt
                        />
                        <img
                          class="profile-img"
                          v-else
                          src="@/assets/icons/logo_avatar.svg"
                          alt
                        />
                        <span class="name"
                          >{{ item.first_name | validate }}
                          {{ item.last_name | validate }}</span
                        >
                      </div>
                    </div>
                    <div class="other-info">
                      <div class="col">
                        <div class="content" v-if="lead.roles">
                          <h5>Role</h5>
                          <p>{{ lead.roles | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.due_date_from">
                          <h5>Start Date</h5>
                          <p>
                            {{ lead.due_date_from | formatDate | validate }}
                            <template v-if="lead.is_urgent"
                              >/ As soon as possible</template
                            >
                          </p>
                        </div>
                      </div>
                      <div class="col">
                        <div class="content" v-if="lead.duration">
                          <h5>Duration</h5>
                          <p>{{ lead.duration | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.workload">
                          <h5>Work Load</h5>
                          <p>{{ lead.workload | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.rate">
                          <h5>Rate</h5>
                          <p>
                            {{ lead.rate | validate }}
                            <template v-if="lead.is_negotiable"
                              >/ Negotiable</template
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="assignments-item-body-option">
                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                    >
                      <span
                        class="fa fa-angle-up"
                        v-show="options.expanded"
                      ></span>
                    </button>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <!-- Our Assignment -->
        <ul class="assignments-items" v-if="tab == 'our'">
          <li class="assignments-starter"></li>
          <li
            class="assignments-item"
            v-for="(lead, i) in our_assignment"
            :key="i"
          >
            <panel-expand :expand="i === 0">
              <template v-slot:header="{ options }">
                <div class="assignments-item-header">
                  <div class="assignments-item-brand">
                    <img
                      v-if="user.company_info.company_logo"
                      :src="
                        $fullUrl(
                          'images/profiles/' + user.company_info.company_logo
                        )
                      "
                    />
                    <img
                      v-else
                      @click.prevent="
                        $router.push({
                          name: 'profile_customer',
                          params: { id: lead.user_id },
                        })
                      "
                      src="@/assets/icons/logo_avatar.svg"
                    />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{
                        user.company_info.company_name | validate
                      }}</label>
                      <span>{{ user.company_info.address | validate }}</span>
                      <span class="date">{{
                        lead.due_date_from | formatDate | validate
                      }}</span>
                    </div>
                    <div class="options">
                      <dropdown-menu>
                        <ul>
                          <li>
                            <a href @click.prevent="assingConsultant(lead)"
                              >Assign</a
                            >
                          </li>
                          <li v-if="lead.status == 0">
                            <a href @click.prevent="publish(lead.id)"
                              >Publish</a
                            >
                          </li>
                          <li v-else>
                            <a href @click.prevent="unpublish(lead.id)">
                              Unpublish</a
                            >
                          </li>
                          <li>
                            <a href="#" @click="editAssignment(lead)">Edit</a>
                          </li>
                          <li>
                            <app-dialog
                              title="Delete Assignment"
                              ask="Are you sure you want to permanently delete this assignment?"
                              yesText="Delete"
                              noText="Cancel"
                              yesBtnClass="btn-danger"
                              @onComfirm="deleteAssingment(lead, i)"
                            >
                              <a href="#">Delete</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdown-menu>

                      <button
                        class="toogle-panel-btn"
                        @click="options.expanded = !options.expanded"
                        v-if="!options.expanded"
                      >
                        <span class="fa fa-angle-down"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:main="{ options }">
                <div class="assignments-item-body">
                  <div class="assignments-info">
                    <h5>{{ lead.title | validate }}</h5>
                    <img
                      class="cover-img"
                      :src="$fullUrl('images/profiles/' + lead.cover_photo)"
                      v-if="lead.cover_photo"
                      alt
                    />
                    <p v-readMore:200="lead.description"></p>
                    <h5>Skills</h5>
                    <div class="assign-skills-widget">
                      <div
                        class="item"
                        v-for="(skill, i) in lead.skills"
                        :key="i"
                      >
                        <span class="name">{{ skill | validate }}</span>
                      </div>
                    </div>
                    <div class="other-info">
                      <div class="col">
                        <div class="content" v-if="lead.roles">
                          <h5>Role</h5>
                          <p>{{ lead.roles | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.due_date_from">
                          <h5>Start Date</h5>
                          <p>
                            {{ lead.due_date_from | formatDate | validate }}
                            <template v-if="lead.is_urgent"
                              >/ As soon as possible</template
                            >
                          </p>
                        </div>
                      </div>
                      <div class="col">
                        <div class="content" v-if="lead.duration">
                          <h5>Duration</h5>
                          <p>{{ lead.duration | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.workload">
                          <h5>Work Load</h5>
                          <p>{{ lead.workload | validate }}</p>
                        </div>
                        <div class="content" v-if="lead.rate">
                          <h5>Rate</h5>
                          <p>
                            {{ lead.rate | validate }}
                            <template v-if="lead.is_negotiable"
                              >/ Negotiable</template
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="assignments-item-body-option">
                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                    >
                      <span
                        class="fa fa-angle-up"
                        v-show="options.expanded"
                      ></span>
                    </button>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
      </div>
      <div
        class="company-profile-body"
        v-if="user.assignment_assigned.length == 0 && tab == 'assing'"
      >
        <div class="empty-widget">
          <div class="empty-widget-body">
            <p>You do no have any assigned asignments yet</p>
          </div>
        </div>
      </div>
      <div
        class="company-profile-body"
        v-if="leads.length == 0 && tab == 'inter'"
      >
        <div class="empty-widget">
          <div class="empty-widget-body">
            <p>We don't have any public asignments yet</p>
          </div>
        </div>
      </div>
      <div
        class="company-profile-body"
        v-if="our_assignment.length == 0 && tab == 'our'"
      >
        <div class="empty-widget">
          <div class="empty-widget-body">
            <p>You do no have any asignments yet</p>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- Add and Update form -->
    <div class="add-update-form" v-if="add_assignment_modal">
      <add-assignment
        @onClose="showList()"
        :value="assignment_selected_item"
        :company_id="user.company_info.id"
        @onFinish="afterAssignementAdded()"
      />
    </div>
    <!-- Select consultant -->
    <div class="select-consultant-wrapper" v-if="show_select_consultants">
      <selectConsultants
        :value="assignment_selected_item"
        @onClose="show_select_consultants = false"
      />
    </div>
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import Loading from "@/components/Loader/Loading";
import lottie from "lottie-web";
import * as animationData from "@/assets/json/loader";
import addAssignment from "@/components/Company/addAssignment.vue";
import selectConsultants from "@/components/Company/selectConsultants.vue";
export default {
  name: "Assignment",
  components: {
    panelExpand,
    dropdownMenu,
    appDialog,
    Loading,
    addAssignment,
    selectConsultants,
  },
  props: {},
  data: () => {
    return {
      tab: "our",
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
        projects: [],
        assignment_assigned: [],
      },
      leads: [],
      add_assignment_modal: false,
      assignment_selected_item: null,
      search_assignment: "",
      showLoading: false,
      anim: null,
      show_list: true,
      show_select_consultants: false,
    };
  },
  mounted() {
    let vm = this;
    vm.anim = lottie.loadAnimation({
      container: vm.$refs.loader,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData.default,
    });
    vm.getAssignment();
    vm.getAllStartData();
    vm.$store.dispatch("GET_ASSIGNMENT");
  },
  computed: {
    ...mapGetters(["assignment"]),
    our_assignment() {
      let vm = this;
      return vm.assignment;
    },
  },
  methods: {
    assingConsultant(item) {
      let vm = this;
      vm.show_select_consultants = true;
      vm.assignment_selected_item = item;
    },
    getAllStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;
          vm.user.assignment_assigned = vm.user.assignment_assigned.map(
            (item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", address);
              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              eventBus.$set(item, "all_skills", skills);
              eventBus.$set(item, "less_skills", skills.slice(0, 3));
              item.skills = item.less_skills;
              return item;
            }
          );
        })
        .catch((error) => {});
    },
    showAddUpdateForm() {
      let vm = this;
      vm.add_assignment_modal = true;
      vm.assignment_selected_item = {};
      vm.show_list = false;
    },
    showList() {
      let vm = this;
      vm.add_assignment_modal = false;
      vm.show_list = true;
    },
    afterAssignementAdded() {
      let vm = this;
      vm.showList();
      vm.getAssignment();
      vm.$store.dispatch("GET_ASSIGNMENT");
    },
    getAssignment() {
      let vm = this;
      vm.showLoading = true;
      vm.$store
        .dispatch("GET_ALL_ASSIGNMENT")
        .then((value) => {
          vm.showLoading = false;
          vm.leads = value.data.data.map((item) => {
            let roles = item.role;
            let skills = [];
            let loc = "";
            if (item.user) {
              if (item.user.customer_profile)
                eventBus.$set(
                  item,
                  "customer",
                  item.user.customer_profile.name
                );
              else eventBus.$set(item, "customer", item.user.username);
            } else eventBus.$set(item, "customer", "");

            eventBus.$set(item, "address", item.address);

            eventBus.$set(item, "more_skills", false);

            item.skills.forEach((skill) => {
              skill.roles.forEach((i) => {
                skills.push(i.name);
              });
              skill.tools.forEach((i) => {
                skills.push(i.name);
              });
              skill.domains.forEach((i) => {
                skills.push(i.name);
              });
              skill.competences.forEach((i) => {
                skills.push(i.name);
              });
              skill.languages.forEach((i) => {
                skills.push(i.name);
              });
            });
            item.roles = roles;
            eventBus.$set(item, "all_skills", skills);
            eventBus.$set(item, "less_skills", skills.slice(0, 3));
            item.skills = item.less_skills;

            return item;
          });
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    searchAssignment(string) {
      let vm = this;
      vm.showLoading = true;
      if (vm.tab == "all") {
        vm.$store
          .dispatch("SEARCH_ASSIGNMENT", { query: string })
          .then((value) => {
            vm.showLoading = false;
            vm.leads = value.data.map((item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);

              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              item.skills = skills;

              return item;
            });
          })
          .catch((error) => {
            vm.showLoading = false;
            console.error({ error });
          });
      } else if (vm.tab == "assing") {
        vm.$store
          .dispatch("SEARCH_ASIGNED_ASSIGNMENT", { query: string })
          .then((value) => {
            vm.showLoading = false;
            vm.user.assignment_assigned = value.data.map((item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);

              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              item.skills = skills;

              return item;
            });
          })
          .catch((error) => {
            vm.showLoading = false;
            console.error({ error });
          });
      }
    },
    deleteAssingment(item, i) {
      let vm = this;
      vm.$store
        .dispatch("DELETE_ASSIGNMENT", { id: item.id })
        .then((response) => {
          vm.our_assignment.splice(i, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editAssignment(item) {
      let vm = this;
      vm.add_assignment_modal = true;
      vm.assignment_selected_item = item;
      vm.show_list = false;
    },
    unpublish(id) {
      this.$store.dispatch("UNPUBLISH_ASSIGNMENT", { id: id });
    },
    publish(id) {
      this.$store.dispatch("PUBLISH_ASSIGNMENT", { id: id });
    },
  },
  watch: {
    search_assignment: function (val) {
      if (val != "") {
        this.searchAssignment(val);
      } else {
        this.getAssignment();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.company-profile-wrapper {
  width: 100%;
  .company-profile-container {
    padding: 1px;
    .company-profile-body {
      border-radius: 5px;
      margin-bottom: 20px;
      background: #fff;
      .tabs {
        display: grid;
        grid-template-columns: 33.333% 33.333% 33.333%;
        .tab:nth-child(1) {
          border-top-left-radius: 5px;
        }
        .tab:nth-child(3) {
          border-top-right-radius: 5px;
        }
        .tab {
          background: #cccccc;
          height: 55px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 500ms ease-in-out;
          &.active {
            background: #fff;
            color: #1ba5a4;
            font-weight: 800;
            transition: 500ms ease-in-out;
          }
          &:hover {
            color: #1ba5a4;
          }
        }
      }
      .assignments-item-header {
        display: flex;
        justify-content: space-between;
        padding: 24px 22px;
        .options {
          .add-btn {
            color: #1885ad;
            display: flex;
            font-style: italic;
            outline: none;
          }
        }
      }
      .search-add-btn-widget {
        background: #fff;
        padding: 0px 20px;
        display: grid;
        grid-template-columns: 100%;
        grid-column-gap: 20px;
        .search-widget {
          border: 1px solid #ccc;
          height: 45px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;
          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 45px;
            width: 100%;
            padding-left: 15px;
            outline: none;
          }
        }
        .add-btn {
          width: 191px;
          height: 45px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          opacity: 1;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin-left: 10px;
          }
        }
      }
      .loader {
        height: 80px;
        margin-top: 10px;
        background: #fff;
        position: relative;
        padding: 10px 0 0 0;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
        border-radius: 5px;
        margin-bottom: 20px;
        svg {
          width: 70px !important;
        }
      }
      ul.assignments-items {
        background: #ffffff;
        padding: 0px 20px;
        padding-bottom: 20px;
        list-style: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        .assignments-starter {
          margin-bottom: 6px;
          .assignments-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;

              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;

              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
          }
        }
        .assignments-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          padding: 0px 10px;
          position: relative;
          .assignments-item-header {
            display: grid;
            padding: 0px 4px;
            grid-template-columns: 90px calc(98% - 90px);
            grid-column-gap: 20px;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 60px calc(98% - 60px);
              grid-column-gap: 10px;
              padding: 4px 4px;
            }
            .assignments-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 60px;
                height: 60px;
              }
              img {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                object-fit: cover;
                @media (min-width: 300px) and (max-width: 630px) {
                  width: 50px;
                  height: 50px;
                }
              }
            }
            .content {
              display: flex;
              width: 100%;
              padding-right: 5px;
              justify-content: space-between;
              align-items: flex-start;
              padding-top: 15px;
              .title-row {
                label {
                  display: block;
                  font-size: 14px;

                  margin-bottom: 1px;
                  font-weight: 800;
                }
                span {
                  color: #808080;

                  font-size: 13px;
                  margin-bottom: 2px;
                  display: block;
                }
              }
              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;
                .date {
                  color: #808080;

                  font-size: 13px;
                  display: flex;
                  justify-content: flex-end;
                  width: 188px;
                  align-items: center;
                  .separator {
                    margin: 0px 5px;
                  }
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 11px;
                    width: 145px;
                  }
                }
                .status {
                  color: #000;

                  font-size: 13px;
                }

                .publish-btn,
                .un-publish-btn {
                  border: 1px solid #2f90b6;
                  border-radius: 5px;
                  padding: 6px 20px;
                  color: #2f90b6;
                  background: transparent;
                  cursor: pointer;
                }
              }
            }
            .toogle-panel-btn {
              padding: 1px 7px;
              font-size: 16px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              position: absolute;
              bottom: 10px;
              right: 5px;
              height: 15px;
            }
          }
          .assignments-item-body {
            padding: 10px;
            .assignments-info {
              h5 {
                text-align: left;
                color: #6e6e6e;
                font-size: 14px;
              }
              p {
                text-align: left;
                color: #000;
                font-size: 13px;
                font-weight: 800;
              }
              .cover-img {
                width: 100%;
              }
              .other-info {
                display: grid;
                grid-template-columns: 48% 48%;
                grid-column-gap: 20px;
                .col {
                  padding: 20px 0px;
                }
              }
              .assign-skills-widget {
                padding: 10px 0px;
                display: flex;
                flex-wrap: wrap;
                .item {
                  background: #707070 0% 0% no-repeat padding-box;
                  border-radius: 20px;
                  display: flex;
                  align-items: center;
                  padding: 4px 38px;
                  margin-right: 8px;
                  margin-bottom: 8px;
                  .name {
                    color: #fff;
                  }
                }
              }
              .collaboraters-widget {
                padding: 10px 0px;
                display: flex;
                flex-wrap: wrap;
                .item {
                  background: #1ba5a4 0% 0% no-repeat padding-box;
                  border-radius: 20px;
                  display: flex;
                  align-items: center;
                  padding: 4px 4px;
                  margin-right: 8px;
                  margin-bottom: 8px;
                  .profile-img {
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    margin-right: 5px;
                  }
                  .name {
                    color: #fff;
                  }
                }
              }
            }
            .assignments-item-body-option {
              display: flex;
              justify-content: flex-end;
              .toogle-panel-btn {
                padding: 1px 9px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
                height: 36px;
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: relative;
                top: -3px;
                right: -5px;
              }
            }
          }
        }
      }
      .empty-widget {
        background: #fff;
        padding: 20px;
        .empty-widget-body {
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          p {
            text-align: center;
            width: 270px;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
  }
  .information-container {
    background: #f5f5f5 0% 0% no-repeat padding-box;
    border-radius: 5px;
    padding: 40px;
    .information-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      .information-brand {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 100px;
          margin-right: 20px;
        }
        span {
        }
      }
      .information-options {
        .btn-edit-info {
          box-shadow: 0px 1px 3px #00000029;
          border: 1px solid #36adae;
          border-radius: 5px;
          color: #1885ad;
          padding: 10px 50px;
        }
      }
    }
    .information-body {
      padding: 20px;
      ul {
        margin-left: -38px;
        list-style: none;
        .information-item {
          margin-bottom: 30px;
          label {
            color: #808080;
          }
          p {
            color: #131313;
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>